import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { Router } from "@angular/router";
import swal from "sweetalert2";
import { ProjectsService } from "../../services/projects/projects.service";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { UserServiceService } from "../../services/user-service/user-service.service";

@Component({
  selector: "app-brokers",
  templateUrl: "./brokers.component.html",
  styleUrls: ["./brokers.component.css"],
})
export class BrokersComponent implements OnInit {
  readonly brokerDetailFields = [
    { key: "name", label: "Broker Name" },
    { key: "name_ar", label: "Broker Name Ar" },
    { key: "phone", label: "Phone" },
    { key: "contact_phone", label: "Contact Phone" },
    { key: "contact_address", label: "Address" },
    { key: "contact_email", label: "Contact Email" },
    { key: "owner_name", label: "Owner Name" },
    { key: "commercial_register", label: "Commercial Register" },
    { key: "tax_id", label: "Tax ID" },
    { key: "contract_end_date", label: "Contract End Date" },
    { key: "contract_status", label: "Contract Status" },
    { key: "user_id", label: "P.C In Charge" },
  ];
  userData: any = JSON.parse(window.localStorage.getItem("userProfile"));
  pagination_meta = {
    page: 1,
    totalPages: 0,
  };
  brokers_raw_data: any;
  brokers: any;
  brokersListAll: any[] = [];
  brokersList: any[] = [];
  brokersLoading = false;
  brokersLoadingMore = false;
  brokersHasMore = true;
  private brokersBottomLoadLocked = false;
  pcsList: any[] = [];
  agentOptions: Array<{ id: string; name: string }> = [];
  incentiveOptions: any[] = [];

  is_refreshing = false;
  filterForm: FormGroup;
  filterActive = false;
  filterData: any;

  pagination: any = [];
  oldBroker: any = {};
  page_length: number = 100;

  selectedBroker: any;
  filterOpen = false;

  activeTab: "activity" | "documents" | "commissions" | "incentives" = "activity";
  brokerDocuments: any[] = [];
  documentsLoading = false;

  brokerDocumentForm: FormGroup;
  brokerToUploadDocumentId;
  @ViewChild("documentFile") documentFile;

  brokerCommissionData: any = {};
  projects: Array<any> = [];
  commissionsLoading = false;

  pendingIncentiveForBrokerChange: any = null;
  changeBrokerSelectedId: any = '';

  commissionSubTab: 'default' | 'flat' | 'custom_target' = 'default';
  tempBrokerCommissionData: any = {
    commission_type: 'default',
    commission_rate: 0,
    target_upto: [],
    commission: []
  };
  commissionInfo: any[] = [];

  activityLogsMock: any[] = [];

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private fb: FormBuilder,
    private userService: UserServiceService,
    private projectService: ProjectsService,
    private router: Router,
    private errorHandlerService: ErrorHandlerService
  ) { }

  ngOnInit() {
    this.createFilter();
    this.loadPcOptions();
    this.getBrokers();
    this.getprojects();
    this.getIncentiveOptions();
    this.brokerDocumentForm = this.fb.group({
      file: [null, Validators.required],
      name: [null],
    });
  }

  getBrokers(reset = false, append = false, filters: any = {}) {
    if (reset) {
      this.pagination_meta.page = 1;
      this.brokersListAll = [];
      this.brokersList = [];
      this.brokersHasMore = true;
      this.brokersBottomLoadLocked = false;
    }
    const fv = this.filterForm.value || {};
    const payload = Object.assign({ keyword: fv.q || "", page: this.pagination_meta.page, page_length: this.page_length }, filters);
    if (append) {
      this.brokersLoadingMore = true;
    } else {
      this.brokersLoading = true;
      this.slimLoadingBarService.start();
    }
    this.userService.getBrokersPaginated(payload).subscribe(
      (res: any) => {
        if (!append) {
          this.slimLoadingBarService.complete();
        }
        this.brokers_raw_data = res;
        this.brokers = res.data;
        this.pagination_meta.totalPages = res.last_page;
        this.brokersHasMore = this.pagination_meta.page < (res.last_page || 0);
        this.brokersListAll = append ? [...this.brokersListAll, ...(res.data || [])] : res.data || [];
        this.brokersList = [...this.brokersListAll];
        this.refreshAgentOptions();
        this.ensureSelectedBroker(this.brokersListAll, append);
        this.brokersLoading = false;
        this.brokersLoadingMore = false;
        this.brokers.length > 0 && (this.selectedBroker = this.brokers[0]);
      },
      (err) => {
        if (!append) {
          this.slimLoadingBarService.reset();
        }
        this.brokersLoading = false;
        this.brokersLoadingMore = false;
        this.brokersBottomLoadLocked = false;
      }
      );
  }

  loadPcOptions() {
    this.userService.getPcs().subscribe(
      (res: any) => {
        this.pcsList = this.normalizeCollection(res);
        this.refreshAgentOptions();
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getFilteredBrokers() {
    const contactPhone = this.normalizeContactPhone(
      this.filterForm.value.contact_phone
    );

    const payload = {
      ...this.filterForm.value,
      contact_phone: contactPhone,
      paginate: false,
    };

    this.brokersLoading = true;
    this.brokersLoadingMore = false;
    this.brokersHasMore = false;
    this.brokersBottomLoadLocked = false;
    this.slimLoadingBarService.start();

    this.userService.getBorkers(payload).subscribe(
      (res: any) => {
        const brokers = this.normalizeCollection(res);
        this.brokers_raw_data = {
          data: brokers,
          current_page: 1,
          last_page: 1,
          total: brokers.length,
        };
        this.brokers = brokers;
        this.brokersListAll = brokers;
        this.brokersList = [...brokers];
        this.pagination_meta.page = 1;
        this.pagination_meta.totalPages = 1;
        this.refreshAgentOptions();
        this.ensureSelectedBroker(brokers, false);
        this.slimLoadingBarService.complete();
        this.brokersLoading = false;
      },
      (err) => {
        this.brokersLoading = false;
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  private normalizeContactPhone(value: any): string {
    const phone = (value || "").toString().trim();
    if (!phone) {
      return "";
    }

    if (phone.startsWith("+")) {
      return phone;
    }

    if (phone.startsWith("0")) {
      return `+20${phone.slice(1)}`;
    }

    return `+20${phone}`;
  }

  getIncentiveOptions() {
    this.userService.getBrokerIncentives({ paginate: false }).subscribe(
      (res: any) => { this.incentiveOptions = res.data || []; },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  refreshAgentOptions() {
    const map = new Map<string, string>();
    (this.pcsList || []).forEach((agent) => {
      const id = (agent != null ? (agent.id != null ? agent.id : (agent.user_id != null ? agent.user_id : "")) : "").toString();
      const name = ((agent && agent.name) || (agent && agent.full_name) || "").toString();
      if (id && name && !map.has(id)) {
        map.set(id, name);
      }
    });
    (this.brokersListAll || []).forEach((b) => {
      (((b && b.users_arr) || (b && b.users) || []) as any[]).forEach((u) => {
        const id = (u != null ? (u.id != null ? u.id : (u.user_id != null ? u.user_id : "")) : "").toString();
        const name = ((u && u.name) || "").toString();
        if (id && name && !map.has(id)) {
          map.set(id, name);
        }
      });
    });
    this.agentOptions = Array.from(map.entries())
      .map(([id, name]) => ({ id, name }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  applyClientFilters() {
    const fv = this.filterForm.value || {};
    const q = (fv.q || "").toString().trim().toLowerCase();
    const name = (fv.name || "").toString().trim().toLowerCase();
    const nameAr = (fv.name_ar || "").toString().trim().toLowerCase();
    const contactPhone = (fv.contact_phone || "").toString().trim().toLowerCase();
    const contactEmail = (fv.contact_email || "").toString().trim().toLowerCase();
    const ownerName = (fv.owner_name || "").toString().trim().toLowerCase();
    const commercialRegister = (fv.commercial_register || "").toString().trim().toLowerCase();
    const taxId = (fv.tax_id || "").toString().trim().toLowerCase();
    const contractEndDate = this.normalizeDateValue(fv.contract_end_date);
    const contractStatus = (fv.contract_status || "").toString().trim().toLowerCase();
    const agentId = (fv.agents || "").toString();

    let list = [...(this.brokersListAll || [])];

    if (q) {
      list = list.filter((b) => {
        const bName = ((b && b.name) || "").toString().toLowerCase();
        const bNameAr = ((b && b.name_ar) || "").toString().toLowerCase();
        const phone = ((b && b.phone) || (b && b.contact_phone) || "").toString().toLowerCase();
        const email = ((b && b.contact_email) || "").toString().toLowerCase();
        const bOwnerName = ((b && b.owner_name) || "").toString().toLowerCase();
        return (
          bName.includes(q) ||
          bNameAr.includes(q) ||
          phone.includes(q) ||
          email.includes(q) ||
          bOwnerName.includes(q)
        );
      });
    }

    if (name) {
      list = list.filter((b) => ((b && b.name) || "").toString().toLowerCase().includes(name));
    }

    if (nameAr) {
      list = list.filter((b) => ((b && b.name_ar) || "").toString().toLowerCase().includes(nameAr));
    }

    if (contactPhone) {
      list = list.filter((b) =>
        ((b && b.contact_phone) || "").toString().toLowerCase().includes(contactPhone)
      );
    }

    if (contactEmail) {
      list = list.filter((b) =>
        ((b && b.contact_email) || "").toString().toLowerCase().includes(contactEmail)
      );
    }

    if (ownerName) {
      list = list.filter((b) =>
        ((b && b.owner_name) || "").toString().toLowerCase().includes(ownerName)
      );
    }

    if (commercialRegister) {
      list = list.filter((b) =>
        ((b && b.commercial_register) || "")
          .toString()
          .toLowerCase()
          .includes(commercialRegister)
      );
    }

    if (taxId) {
      list = list.filter((b) => ((b && b.tax_id) || "").toString().toLowerCase().includes(taxId));
    }

    if (contractEndDate) {
      list = list.filter(
        (b) =>
          this.normalizeDateValue((b && b.contract_end_date) || (b && b.contract_renewal_date)) ===
          contractEndDate
      );
    }

    if (contractStatus) {
      list = list.filter((b) =>
        ((b && b.contract_status) || "")
          .toString()
          .toLowerCase()
          .includes(contractStatus)
      );
    }

    if (agentId) {
      list = list.filter((b) =>
        (((b && b.users_arr) || (b && b.users) || []) as any[]).some(
          (u) => (u != null ? (u.id != null ? u.id : (u.user_id != null ? u.user_id : "")) : "").toString() === agentId
        )
      );
    }

    this.brokersList = list;
  }

  ensureSelectedBroker(brokers: any[] = [], append = false) {
    if (append || !Array.isArray(brokers) || !brokers.length) {
      if (!brokers.length) {
        this.selectedBroker = null;
      }
      return;
    }

    const selectedId = this.selectedBroker && this.selectedBroker.id;
    const currentSelectionExists = selectedId
      ? brokers.some((broker) => broker && broker.id === selectedId)
      : false;

    if (currentSelectionExists) {
      return;
    }

    const firstBroker = brokers[0];
    if (!firstBroker || !firstBroker.id) {
      this.selectedBroker = null;
      return;
    }

    this.activeTab = "activity";
    this.getBrokerDetails(firstBroker.id);
  }

  normalizeCollection(res: any): any[] {
    if (Array.isArray(res)) {
      return res;
    }

    if (res && Array.isArray(res.data)) {
      return res.data;
    }

    return [];
  }

  private normalizeDateValue(value: any) {
    if (!value) {
      return "";
    }

    if (typeof value === "string") {
      return value.slice(0, 10);
    }

    if (value instanceof Date && !Number.isNaN(value.getTime())) {
      return value.toISOString().slice(0, 10);
    }

    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? "" : parsedDate.toISOString().slice(0, 10);
  }

  loadMoreBrokers() {
    if (this.brokersLoading || this.brokersLoadingMore || !this.brokersHasMore) {
      return false;
    }
    this.pagination_meta.page += 1;
    this.getBrokers(false, true);
    return true;
  }

  uploadBrokerDocumentModalOpen(broker) {
    this.brokerToUploadDocumentId = broker && broker.id;
  }

  uploadBrokerDocumentModalClose() {
    this.brokerDocumentForm.reset();
    if (this.documentFile && this.documentFile.nativeElement) {
      this.documentFile.nativeElement.value = "";
    }
  }

  uploadBrokerDocument(modal) {
    const payload = {
      documents: this.brokerDocumentForm.get("file").value,
    };

    this.userService.uploadBrokerDocument(this.brokerToUploadDocumentId, payload as any).subscribe(
      () => {
        swal("Success", "Document uploaded successfully", "success");
        this.brokerDocumentForm.reset();
        modal.close();
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  handleDocumentUpload(event) {
    if (event.target.files && event.target.files.length > 0) {
      const files = this.handleFormatMultiple(event.target.files);
      this.brokerDocumentForm.get("file").setValue(files);
    }
  }

  handleFormatMultiple(filesArray) {
    const files = Object.values(filesArray);
    const filesBase46 = [];
    for (let i = 0; i < files.length; i++) {
      const img: any = files[i];
      const reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = () => {
        const imgObject = {
          document_name: img.name,
          document_value: (reader.result as any).split(",")[1],
        };
        filesBase46.push(imgObject);
      };
    }
    return filesBase46;
  }

  loadSelectedBrokerDocuments() {
    if (!this.selectedBroker) {
      return;
    }
    this.documentsLoading = true;
    this.userService.getBrokerDocuments(this.selectedBroker.id).subscribe(
      (res) => {
        this.brokerDocuments = res as any;
        this.documentsLoading = false;
      },
      (err) => {
        this.documentsLoading = false;
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getprojects() {
    this.projectService.getProjects({ is_select_form: true }).subscribe(
      (data: any) => {
        const projectsArray = data.data || data || [];
        this.brokerCommissionData = projectsArray.reduce((obj, project) => {
          obj[project.id] = {
            value: 0,
            commision_id: null,
          };
          return obj;
        }, {});
        this.projects = projectsArray;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  resetCommissions() {
    this.brokerCommissionData = (this.projects || []).reduce((obj, project) => {
      obj[project.id] = {
        value: 0,
        commision_id: null,
      };
      return obj;
    }, {});
  }

  loadSelectedBrokerCommissions() {
    if (!this.selectedBroker) {
      return;
    }
    if (!this.projects || !this.projects.length) {
      return;
    }
    this.resetCommissions();
    this.commissionsLoading = true;
    this.userService.getBrokerCommissions(this.selectedBroker.id).subscribe(
      (data: any) => {
        (data || []).map((d) => {
          if (this.brokerCommissionData[d.project_id]) {
            this.brokerCommissionData[d.project_id].value = d.commission;
            this.brokerCommissionData[d.project_id].commission_id = d.id;
          }
        });
        this.commissionsLoading = false;
      },
      (err) => {
        this.commissionsLoading = false;
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  saveSelectedBrokerCommissions() {
    if (!this.selectedBroker) {
      return;
    }
    const payload = {
      commissions: (this.projects || []).map((proj) => ({
        project_id: proj.id,
        commission: (this.brokerCommissionData && this.brokerCommissionData[proj.id] && this.brokerCommissionData[proj.id].value) || 0,
      })),
    };
    this.userService.updateBrokerCommissions(this.selectedBroker.id, payload).subscribe(
      () => swal("Success", "Commissions uploaded successfully", "success"),
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  onListScroll(event: any) {
    const el = event && event.target;
    if (!el) {
      return;
    }
    const threshold = 120;
    const isNearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;
    if (!isNearBottom) {
      this.brokersBottomLoadLocked = false;
      return;
    }

    if (this.brokersBottomLoadLocked) {
      return;
    }

    if (this.loadMoreBrokers()) {
      this.brokersBottomLoadLocked = true;
    }
  }

  setActiveTab(tab: "activity" | "documents" | "commissions" | "incentives") {
    this.activeTab = tab;
    if (tab === "documents") {
      this.loadSelectedBrokerDocuments();
    }
    if (tab === "commissions") {
      this.loadSelectedBrokerCommissions();
      this.initCommissionData();
    }
  }

  selectBroker(broker) {
    this.activeTab = "activity";
    this.getBrokerDetails(broker.id);
  }

  getBrokerDetails(broker_id: number | string) {
    this.slimLoadingBarService.start();
    this.userService.getBrokerById(broker_id).subscribe(
      (res) => {
        this.selectedBroker = res;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  setCommissionSubTab(tab: 'default' | 'flat' | 'custom_target') {
    this.commissionSubTab = tab;
    this.tempBrokerCommissionData.commission_type = tab;
  }

  initCommissionData() {
    if (!this.selectedBroker) return;
    this.tempBrokerCommissionData = {
      commission_type: this.selectedBroker.commission_type || 'default',
      commission_rate: this.selectedBroker.commission_rate || 0,
      target_upto: this.selectedBroker.target_upto || [],
      commission: this.selectedBroker.commission || []
    };
    this.commissionSubTab = this.tempBrokerCommissionData.commission_type;

    this.commissionInfo = [];
    if (this.selectedBroker.target_commissions) {
      this.selectedBroker.target_commissions.forEach((item) => {
        this.commissionInfo.push({
          target_upto: item.target_upto,
          commission: item.commission
        });
      });
    } else if (this.tempBrokerCommissionData.target_upto && this.tempBrokerCommissionData.commission) {
      this.tempBrokerCommissionData.target_upto.forEach((upto, index) => {
        this.commissionInfo.push({
          target_upto: upto,
          commission: this.tempBrokerCommissionData.commission[index]
        });
      });
    }
  }

  addCommissionRow() {
    this.commissionInfo.push({ target_upto: null, commission: null });
  }

  removeCommissionRow(index: number) {
    this.commissionInfo.splice(index, 1);
  }

  saveBrokerCommissionDetails() {
    if (!this.selectedBroker) return;

    const payload: any = {
      commission_type: this.commissionSubTab,
    };

    if (this.commissionSubTab === 'flat') {
      payload.commission_rate = this.tempBrokerCommissionData.commission_rate;
    } else if (this.commissionSubTab === 'custom_target') {
      payload.target_upto = this.commissionInfo.map(i => i.target_upto);
      payload.commission = this.commissionInfo.map(i => i.commission);
    }

    const fullPayload = Object.assign({}, this.selectedBroker, payload);

    if (this.commissionSubTab === 'default') {
      delete fullPayload.commission_rate;
      delete fullPayload.target_upto;
      delete fullPayload.commission;
      delete fullPayload.target_commissions;
    } else if (this.commissionSubTab === 'flat') {
      delete fullPayload.target_upto;
      delete fullPayload.commission;
      delete fullPayload.target_commissions;
    } else if (this.commissionSubTab === 'custom_target') {
      delete fullPayload.commission_rate;
    }

    if (fullPayload.users && Array.isArray(fullPayload.users)) {
      fullPayload.users = fullPayload.users.map(u => (typeof u === 'object' && u.id) ? u.id : u);
    }
    delete fullPayload.edit_mode;
    delete fullPayload.users_arr;

    this.userService.editBroker(this.selectedBroker.id, fullPayload).subscribe(
      (res) => {
        swal("Success", "Commission details updated successfully", "success");
        Object.assign(this.selectedBroker, payload);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  createFilter() {
    this.filterForm = this.fb.group({
      q: "",
      name: "",
      name_ar: "",
      contact_phone: "",
      contact_email: "",
      owner_name: "",
      commercial_register: "",
      tax_id: "",
      contract_end_date: "",
      contract_status: "",
      countryCode: "",
      consultantId: "",
      teamId: "",
      activityId: "",
      channelId: "",
      sourceId: "",
      projectId: "",
      campaignId: "",
      agents: "",
      broker_incentive_id: "",
      paginate: 1,
    });
  }

  getBrokerFirstUserName(broker: any): string {
    const users = (broker && (broker.users_arr || broker.users)) || [];
    return (users[0] && users[0].name) || '';
  }

  getBrokerFieldValue(broker: any, key: string) {
    if (!broker) {
      return "—";
    }

    if (key === "contract_end_date") {
      return broker.contract_end_date || broker.contract_renewal_date || "—";
    }

    if (key === "user_id") {
      const users = broker.users_arr || broker.users || [];
      if (!Array.isArray(users) || !users.length) {
        return "—";
      }
      return users
        .map((user) => (user && user.name) || (user && user.user && user.user.name) || (user && user.user_id) || (user && user.id))
        .filter(Boolean)
        .join(", ");
    }

    return broker[key] || "—";
  }

  resetFilters() {
    this.createFilter();
    this.getBrokers(true);
  }

  edit_broker(broker) {
    if (!broker || broker.id == null) {
      swal("Missing broker id", "", "error");
      return;
    }
    window.localStorage.setItem("edit_broker_settings", JSON.stringify(broker));
    this.router.navigateByUrl(`/pages/brokers/add/${broker.id}`);
  }

  deleteBrokerDocument(broker, document_id) {
    this.userService.deleteBrokerDocument(broker, document_id).subscribe(
      (res: any) => {
        this.brokerDocuments = res;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  deactivate_broker(index) {
    this.slimLoadingBarService.start();
    let broker = this.brokers[index];
    const broker_id = broker.id;
    this.userService
      .activeBroker(broker_id, Number(!broker.is_active))
      .subscribe(
        (data) => {
          this.brokers[index].is_active = Number(!broker.is_active);
          swal(
            `${broker.is_active ? "Deactivated" : "Activated"} successfully`,
            "",
            "success"
          );
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  sendIncentiveToErp(incentive: any) {
    swal({
      title: 'Are you sure?',
      text: 'This will send the incentive to ERP. This action cannot be undone.',
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Yes, Send',
      confirmButtonColor: '#3085d6',
    }).then((res) => {
      if (res.value) {
        this.userService.sendBrokerIncentiveToErp(incentive.id).subscribe(
          () => swal('Success', 'Incentive sent to ERP successfully', 'success'),
          (err) => this.errorHandlerService.handleErorr(err)
        );
      }
    });
  }

  changeIncentiveBroker(incentive: any, modal: any) {
    this.pendingIncentiveForBrokerChange = incentive;
    this.changeBrokerSelectedId = '';
    modal.open();
  }

  confirmChangeBroker(modal: any) {
    if (!this.changeBrokerSelectedId) {
      swal('Error', 'Please select a broker.', 'error');
      return;
    }
    this.userService.changeBrokerIncentiveBroker(this.pendingIncentiveForBrokerChange.id, this.changeBrokerSelectedId).subscribe(
      () => {
        swal('Success', 'Broker changed successfully', 'success');
        modal.close();
        this.getBrokerDetails(this.selectedBroker.id);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  sendToErp(broker: any) {
    swal({
      title: 'Are you sure?',
      text: 'This will send the broker to ERP. This action cannot be undone.',
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Yes, Send',
      confirmButtonColor: '#3085d6',
    }).then((res) => {
      if (res.value) {
        this.userService.sendBrokerToErp(broker.id).subscribe(
          () => swal('Success', 'Broker sent to ERP successfully', 'success'),
          (err) => this.errorHandlerService.handleErorr(err)
        );
      }
    });
  }

  toggleSelectedBrokerActive() {
    const isActive = this.selectedBroker && this.selectedBroker.is_active;
    swal({
      title: "Are you sure?",
      text: `Once ${isActive ? "deactivated" : "activated"}, this broker will ${isActive ? "not be able to access the system" : "access the system"}!`,
      type: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      confirmButtonColor: "#d33",
    }).then((res) => {
      if (res.value) {
        if (!this.selectedBroker || !this.brokers) {
          return;
        }
        const index = this.brokers.findIndex((b) => b.id === this.selectedBroker.id);
        if (index === -1) {
          return;
        }
        this.deactivate_broker(index);
      } else if (res.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cancelBroker(index) {
    this.brokers[index] = this.oldBroker;
    this.brokers[index].edit_mode = false;
  }

  delete_broker(id) {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this broker!",
      type: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      confirmButtonColor: "#d33",
    }).then((res) => {
      if (res.value) {
        this.slimLoadingBarService.start();
        this.userService.deleteBroker(id).subscribe(
          (res) => {
            swal("Success", "Broker deleted successfully", "success");
            this.slimLoadingBarService.complete();
            this.getBrokers();
          },
          (err) => this.errorHandlerService.handleErorr(err)
        );
      } else if (res.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  filter() {
    this.filterOpen = false;
    this.getFilteredBrokers();
  }

  resetFilter() {
    this.filterOpen = false;
    this.pagination_meta.page = 1;
    this.createFilter();
    this.applyClientFilters();
    this.getBrokers(true, false);
    this.selectedBroker = null;
    this.activeTab = "activity";
  }

  exportBrokers() {
    this.slimLoadingBarService.start();
    this.userService.exportBrokers().subscribe(
      (data: any) => {
        const exportUrl = data && data.url;
        if (exportUrl) {
          window.open(exportUrl, "_blank");
        }
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  importBrokers(event: any) {
    const file = event.target.files && event.target.files[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const dataUrl = reader.result as string;
      const payload = {
        file_name: file.name,
        file: dataUrl.split(",")[1],
      };
      this.slimLoadingBarService.start();
      this.userService.importBrokers(payload).subscribe(
        (res: any) => {
          swal("Success", "Brokers imported successfully", "success");
          this.getBrokers(true);
        },
        (err) => {
          this.slimLoadingBarService.complete();
          event.target.value = "";
          this.errorHandlerService.handleErorr(err);
        },
        () => {
          this.slimLoadingBarService.complete();
          event.target.value = "";
        }
      );
    };
    reader.onerror = () => {
      event.target.value = "";
      swal("Error", "Could not read the selected file", "error");
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/brokers/brokers.component.ts